module.exports = __webpack_public_path__ + "static/Synesthesia-84ecbae50155f3be79d97c60423f6da6.gif";